<template>
    <Line :data="chartData" :options="chartOptions" />
  </template>
  
  <script>
  import { Line } from 'vue-chartjs';
  import { Chart, registerables } from 'chart.js';
  import zoomPlugin from 'chartjs-plugin-zoom';
  import 'chartjs-adapter-date-fns';
  
  Chart.register(...registerables, zoomPlugin);
  
  export default {
    name: 'MultiSignalChart',
    components: { Line },
    props: {
      signals: Array, // Array of signal objects { label, data }
    },
    computed: {
      chartData() {
        const colors = ['red', 'orange', 'yellow', 'blue']
        return {
          labels: this.signals[0]?.data.map((_, index) => index + 1), // Use index as labels
          datasets: this.signals.map((signal, index) => ({
            label: signal.label,
            data: signal.data,
            borderColor: colors[index], // Assign a unique color to each signal
            fill: false,
          })),
        };
      },
      chartOptions() {
        return {
          responsive: true,
          maintainAspectRatio: true,
          aspectRatio: 2,
          layout: { padding: 10 },
          scales: {
            x: {
              title: {
                display: true,
                text: 'Sample Index',
              },
            },
            y: {
              title: {
                display: true,
                text: 'Amplitude',
              },
            },
          },
          plugins: {
            legend: { display: true, position: 'top' },
            zoom: {
              zoom: { wheel: { enabled: true, modifierKey: 'shift' }, pinch: { enabled: true }, mode: 'xy'},
              pan: { enabled: true, mode: 'xy', modifierKey: 'ctrl' },
            },
          },
        };
      },
    },
  };
  </script>